// removed by extract-text-webpack-plugin
module.exports = {"layout-funky-wrapper":"layout-funky-wrapper___2UvMw","layout-funky-main":"layout-funky-main___1EbwQ","layout-funky-content-wrapper":"layout-funky-content-wrapper___En9Wd","layout-funky-content":"layout-funky-content___2nSnA"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/layout-funky/layout-funky.module.scss
// module id = 1362
// module chunks = 82